module.exports = __webpack_public_path__ + "img/no-result.eeb4de43.svg";